import { useParams } from "react-router-dom";
import FormType from "enums/FormType";
import { useEffect } from "react";

import { loadForm, loadFormNames } from "features/qualityForm/qualityFormSlice";
import { copyFormSliceActions } from "features/qualityForm/formEditor/copyFormSlice";
import FormEditorContainer from "features/qualityForm/formEditor/FormEditorContainer";
import { useAppDispatch } from "app/hooks";
import { useLocale } from "features/i18n/useLocale";

export function SurveyForm() {
    const { surveyFormId } = useParams();
    const locale = useLocale();

    const dispatch = useAppDispatch();
    useEffect(() => {
        if (surveyFormId) {
            dispatch(
                loadForm({
                    formType: FormType.SURVEY,
                    formId: surveyFormId,
                    language: locale,
                })
            );
            dispatch(loadFormNames(FormType.SURVEY));
            dispatch(copyFormSliceActions.initializeCopyingViewMode());
        }
    }, [dispatch, surveyFormId]);

    return <FormEditorContainer formType={FormType.SURVEY} />;
}
